/*
 * Permissions
 *   Permission constants used to define levels of access.
 */

// Permissions for DocTypes
export const docPermConstants = {
  CREATE: "CREATE", // ability to create regardless of role or project assignment (i.e. reports)
  CREATE_LEVEL_2: "CREATE_LEVEL_2", // higher-level create authorization (e.g. only RESR's are able to create new CCOs and manage keywords, etc.)
  VIEW: "VIEW", // ability to view regardless of role or project assignment
  AUTHOR_VIEW: "AUTHOR_VIEW", // ability to view only if user is the author of the content being accessed
  EDIT: "EDIT", // ability to edit regardless of role or project assignment
  EDIT_LEVEL_2: "EDIT_LEVEL_2",
  EDIT_LEVEL_3: "EDIT_LEVEL_3",
  AUTHOR_EDIT: "AUTHOR_EDIT", // ability to edit only if user is the author of the content being accessed
  DELETE: "DELETE", // ability to delete regardless of role or project assignment
  AUTHOR_DELETE: "AUTHOR_DELETE", // ability to delete only if user is the author of the content being accessed
  COPY: "COPY", // ability to copy regardless of role or project assignment
  PROJECT_APPROVE: "PROJ_APPROVE", // ability to approve submitted content within assigned project
  AUTHORIZED: "AUTHORIZED", // unused.
  ALLOW_ANONYMOUS: "ALLOW_ANONYMOUS", // all-access (even w/o login) - DO NOT USE
  VALIDATE: "VALIDATE", //validate new BI/CCO/Location reported from native app
};

export const linkPermConstants = {
  OPEN: "OPEN",
  ALLOW_ANONYMOUS: "ALLOW_ANONYMOUS",
};

export const regionDistricts = {
  CR: [5, 6, 10],
  NR: [1, 2, 3],
};
